var _path, _g, _path2, _mask, _path3, _path4, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNumberSpeak(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83667 1.3999C11.5356 1.39999 12.9214 2.7924 12.9216 4.5083V11.6245C12.9216 11.634 12.9207 11.6434 12.9207 11.6528C12.9134 13.1157 11.8569 14.324 10.4724 14.5571C10.4391 14.5629 10.4056 14.5681 10.3718 14.5728C10.2458 14.5895 10.1176 14.6011 9.98706 14.6011H4.78491C3.08581 14.6011 1.70007 13.2087 1.69995 11.4927V4.37646C1.69995 4.36734 1.70084 4.35823 1.70093 4.34912C1.70777 2.89845 2.74578 1.69649 4.11304 1.44873C4.16878 1.43837 4.2252 1.43047 4.28198 1.42334C4.39762 1.40935 4.51515 1.3999 4.63452 1.3999H9.83667Z",
    fill: "url(#paint0_linear_9308_7428)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_9308_7428)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.82129,
    y: 10.8916,
    width: 6.85342,
    height: 5.87436,
    rx: 0.906537,
    transform: "rotate(-90 3.82129 10.8916)",
    fill: "#8237FF",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -0.3797,
    y: -0.134094,
    width: 20.2865,
    height: 22.2667
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.18px)",
      clipPath: "url(#bgblur_0_9308_7428_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 4.35138,
    d: "M15.4646 14.636C15.4646 16.322 14.1117 17.6905 12.4402 17.6907H7.23804C5.48832 17.6907 4.06246 16.2569 4.06226 14.4915L4.06226 7.37524C4.06244 5.6894 5.42219 4.30795 7.10034 4.30786L11.9529 4.30786L11.989 4.31567C12.0004 4.32059 12.0106 4.32787 12.0193 4.33716L15.4402 8.01685C15.4557 8.03359 15.4646 8.05551 15.4646 8.07837L15.4646 14.636Z",
    fill: "#BA90FF",
    fillOpacity: 0.35,
    stroke: "url(#paint1_linear_9308_7428)",
    strokeWidth: 0.181307,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_9308_7428",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71397 9.57715H7.50504C7.23709 9.57715 7.01489 9.80157 7.01489 10.0722C7.01489 10.3428 7.23709 10.5606 7.50504 10.5606H9.71397C9.98192 10.5606 10.2041 10.3428 10.2041 10.0722C10.2041 9.80157 9.98192 9.57715 9.71397 9.57715ZM7.50506 13.8607H11.0603C11.3282 13.8607 11.5504 13.6363 11.5504 13.3656C11.5504 13.095 11.3282 12.8772 11.0603 12.8772H7.50506C7.23712 12.8772 7.01491 13.095 7.01491 13.3656C7.01491 13.6363 7.23712 13.8607 7.50506 13.8607Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71397 9.57715H7.50504C7.23709 9.57715 7.01489 9.80157 7.01489 10.0722C7.01489 10.3428 7.23709 10.5606 7.50504 10.5606H9.71397C9.98192 10.5606 10.2041 10.3428 10.2041 10.0722C10.2041 9.80157 9.98192 9.57715 9.71397 9.57715ZM7.50506 13.8607H11.0603C11.3282 13.8607 11.5504 13.6363 11.5504 13.3656C11.5504 13.095 11.3282 12.8772 11.0603 12.8772H7.50506C7.23712 12.8772 7.01491 13.095 7.01491 13.3656C7.01491 13.6363 7.23712 13.8607 7.50506 13.8607Z",
    fill: "url(#paint2_linear_9308_7428)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50504 9.57715V9.64967H9.71397V9.57715V9.50463H7.50504V9.57715ZM7.01489 10.0722H7.08742C7.08742 9.84094 7.27782 9.64967 7.50504 9.64967V9.57715V9.50463C7.19636 9.50463 6.94237 9.7622 6.94237 10.0722H7.01489ZM7.50504 10.5606V10.4881C7.27656 10.4881 7.08742 10.3022 7.08742 10.0722H7.01489H6.94237C6.94237 10.3835 7.19763 10.6332 7.50504 10.6332V10.5606ZM9.71397 10.5606V10.4881H7.50504V10.5606V10.6332H9.71397V10.5606ZM10.2041 10.0722H10.1316C10.1316 10.3022 9.94245 10.4881 9.71397 10.4881V10.5606V10.6332C10.0214 10.6332 10.2766 10.3835 10.2766 10.0722H10.2041ZM9.71397 9.57715V9.64967C9.94119 9.64967 10.1316 9.84094 10.1316 10.0722H10.2041H10.2766C10.2766 9.7622 10.0227 9.50463 9.71397 9.50463V9.57715ZM11.0603 13.8607V13.7882H7.50506V13.8607V13.9332H11.0603V13.8607ZM11.5504 13.3656H11.4779C11.4779 13.5969 11.2875 13.7882 11.0603 13.7882V13.8607V13.9332C11.3689 13.9332 11.6229 13.6756 11.6229 13.3656H11.5504ZM11.0603 12.8772V12.9497C11.2887 12.9497 11.4779 13.1356 11.4779 13.3656H11.5504H11.6229C11.6229 13.0544 11.3677 12.8047 11.0603 12.8047V12.8772ZM7.50506 12.8772V12.9497H11.0603V12.8772V12.8047H7.50506V12.8772ZM7.01491 13.3656H7.08744C7.08744 13.1356 7.27658 12.9497 7.50506 12.9497V12.8772V12.8047C7.19765 12.8047 6.94239 13.0544 6.94239 13.3656H7.01491ZM7.50506 13.8607V13.7882C7.27785 13.7882 7.08744 13.5969 7.08744 13.3656H7.01491H6.94239C6.94239 13.6756 7.19638 13.9332 7.50506 13.9332V13.8607Z",
    fill: "url(#paint3_linear_9308_7428)",
    mask: "url(#path-4-inside-1_9308_7428)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 8.52062,
    y: 2.49694,
    width: 8.69557,
    height: 8.83376
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.36px)",
      clipPath: "url(#bgblur_1_9308_7428_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_9308_7428)",
    "data-figma-bg-blur-radius": 2.71961
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-2_9308_7428",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5584 8.60563C13.0139 8.61025 13.6472 8.61223 14.1844 8.61025C14.4595 8.60959 14.5994 8.27757 14.4085 8.07757C13.7184 7.35282 12.4839 6.05579 11.7774 5.31388C11.582 5.1086 11.2402 5.24985 11.2402 5.53434V7.27427C11.2402 8.00431 11.8356 8.60563 12.5584 8.60563Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.5584 8.60563C13.0139 8.61025 13.6472 8.61223 14.1844 8.61025C14.4595 8.60959 14.5994 8.27757 14.4085 8.07757C13.7184 7.35282 12.4839 6.05579 11.7774 5.31388C11.582 5.1086 11.2402 5.24985 11.2402 5.53434V7.27427C11.2402 8.00431 11.8356 8.60563 12.5584 8.60563Z",
    fill: "url(#paint4_linear_9308_7428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1844 8.61025L14.1842 8.53772L14.1841 8.53772L14.1844 8.61025ZM14.4085 8.07757L14.356 8.12758L14.3561 8.12764L14.4085 8.07757ZM11.7774 5.31388L11.7249 5.36388L11.7249 5.36389L11.7774 5.31388ZM12.5584 8.60563L12.5577 8.67814C13.0135 8.68277 13.6471 8.68475 14.1847 8.68277L14.1844 8.61025L14.1841 8.53772C13.6472 8.5397 13.0143 8.53772 12.5591 8.53311L12.5584 8.60563ZM14.1844 8.61025L14.1846 8.68277C14.5246 8.68195 14.695 8.27276 14.461 8.02751L14.4085 8.07757L14.3561 8.12764C14.5037 8.28239 14.3945 8.53722 14.1842 8.53772L14.1844 8.61025ZM14.4085 8.07757L14.4611 8.02756C13.7704 7.30226 12.537 6.00635 11.83 5.26387L11.7774 5.31388L11.7249 5.36389C12.4308 6.10524 13.6664 7.40338 14.356 8.12758L14.4085 8.07757ZM11.7774 5.31388L11.83 5.26388C11.5876 5.00929 11.1677 5.18699 11.1677 5.53434H11.2402H11.3128C11.3128 5.31272 11.5764 5.20791 11.7249 5.36388L11.7774 5.31388ZM11.2402 5.53434H11.1677V7.27427H11.2402H11.3128V5.53434H11.2402ZM11.2402 7.27427H11.1677C11.1677 8.04368 11.7949 8.67815 12.5584 8.67815V8.60563V8.5331C11.8763 8.5331 11.3128 7.96493 11.3128 7.27427H11.2402Z",
    fill: "url(#paint5_linear_9308_7428)",
    mask: "url(#path-6-inside-2_9308_7428)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9308_7428",
    x: 0.0138319,
    y: 0.230629,
    width: 13.4892,
    height: 14.4684,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.90373,
    result: "effect1_foregroundBlur_9308_7428"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_9308_7428_clip_path",
    transform: "translate(0.3797 0.134094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4646 14.636C15.4646 16.322 14.1117 17.6905 12.4402 17.6907H7.23804C5.48832 17.6907 4.06246 16.2569 4.06226 14.4915L4.06226 7.37524C4.06244 5.6894 5.42219 4.30795 7.10034 4.30786L11.9529 4.30786L11.989 4.31567C12.0004 4.32059 12.0106 4.32787 12.0193 4.33716L15.4402 8.01685C15.4557 8.03359 15.4646 8.05551 15.4646 8.07837L15.4646 14.636Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_9308_7428",
    x: 8.52062,
    y: 2.49694,
    width: 8.69557,
    height: 8.83376,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.906537,
    dy: 0.906537
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.906537
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.577356 0 0 0 0 0.359375 0 0 0 0 0.9375 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9308_7428"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9308_7428",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_9308_7428_clip_path",
    transform: "translate(-8.52062 -2.49694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5584 8.60563C13.0139 8.61025 13.6472 8.61223 14.1844 8.61025C14.4595 8.60959 14.5994 8.27757 14.4085 8.07757C13.7184 7.35282 12.4839 6.05579 11.7774 5.31388C11.582 5.1086 11.2402 5.24985 11.2402 5.53434V7.27427C11.2402 8.00431 11.8356 8.60563 12.5584 8.60563Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9308_7428",
    x1: 9.75438,
    y1: 1.3999,
    x2: 9.75438,
    y2: 14.6011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC94FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7947C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9308_7428",
    x1: 5.93929,
    y1: 5.93665,
    x2: 14.5424,
    y2: 14.9935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9308_7428",
    x1: 11.2288,
    y1: 10.3507,
    x2: 6.17736,
    y2: 10.5251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9308_7428",
    x1: 7.73687,
    y1: 10.0762,
    x2: 10.4325,
    y2: 13.6111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9308_7428",
    x1: 14.2657,
    y1: 5.82952,
    x2: 10.6381,
    y2: 5.94299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9308_7428",
    x1: 11.7586,
    y1: 5.61201,
    x2: 13.9411,
    y2: 8.20513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberSpeak);
export default __webpack_public_path__ + "static/media/numberSpeak.03eee26e16f471ad569273c9ec1d4c88.svg";
export { ForwardRef as ReactComponent };